import _jsx from "@babel/runtime/helpers/jsx";
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import SafeAnchor from '../bootstrap/SafeAnchor.js';
import { bsClass, getClassSet, splitBsProps } from '../bootstrap/utils/bootstrapUtils';
class Thumbnail extends React.Component {
  render() {
    const {
      src,
      alt,
      onError,
      onLoad,
      className,
      children,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const Component = elementProps.href ? SafeAnchor : 'div';
    const classes = getClassSet(bsProps);
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, elementProps, {
      className: clsx(className, classes)
    }), /*#__PURE__*/React.createElement("img", {
      src,
      alt,
      onError,
      onLoad
    }), children && /*#__PURE__*/_jsx("div", {
      className: "caption"
    }, void 0, children));
  }
}
export default bsClass('thumbnail', Thumbnail);